export default __webpack_public_path__ + "static/media/Band of the Rampaging.8beb0d37.jpg";